import MainLayout from "../../layout/MainLayout";
import { DownloadOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import FilterSection from "../../components/FilterSection";
import useExpiredToken from "../../utils/useExpiredToken";
import { actionPost } from "../../services/api";
import { useSelector } from "react-redux";
import { Button } from "antd";
import moment from "moment";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import { filterDataFunc } from "../../constant";
import { useNavigate } from "react-router-dom";
import SelectAuditType from "../../components/models/SelectAuditType";
import DataTable from "../../common/Tables/DataTable";

const CompleteCalls = () => {
  const [qaList, setQAList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isAuditTypeModalOpen, setIsAuditTypeModalOpen] = useState(false);

  const expireToken = useExpiredToken();
  const token = useSelector((state) => state.auth.jwtToken);
  const { searchText } = useSelector((state) => state.search);
  const navigate = useNavigate();

  const mappedData = qaList.map((item, i) => ({
    key: item?.id,
    "Agent name": item?.agent_name || null,
    "Call type": item?.call_type || null,
    "Review date": moment(item?.created_at).format("MMMM Do YYYY") || null,
    "Call duration": item?.duration || null,
    "QA Comments Summary": item?.callObservation || null,
    Action: "View",
    // originalItem: item,
  }));

  const filteredData = filterDataFunc(mappedData, searchText);

  const updatedColumns = [
    {
      title: "Agent name",
      dataIndex: "Agent name",
      key: "Agent name",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      // filters: [
      //   { text: "Outgoing", value: "Outgoing" },
      //   { text: "Incoming", value: "Incoming" },
      // ],
      // onFilter: (value, record) => value && record["Call type"] === value,
    },
    {
      title: "Review date",
      dataIndex: "Review date",
      key: "Review date",
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "QA Comments Summary",
      dataIndex: "QA Comments Summary",
      key: "QA Comments Summary",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: (_, record) => (
        <Button
          icon={<DownloadOutlined />}
          // onClick={() => {
          //   const width = window.screen.availWidth;
          //   const height = window.screen.availHeight;

          //   window.open(
          //     `/report-pdf?callId=${record.id}&auditTypeId=1`,
          //     "_blank",
          //     `width=${width},height=${height},left=0,top=0`
          //   );
          // }}
          onClick={() => {
            setSelectedRow(record);
            setIsAuditTypeModalOpen(true);
          }}
        >
          Download
        </Button>
      ),
    },
  ];

  // const fetchCompleteCall = async () => {
  //   const res = await actionPost("calls/summary", token, "READ_COMPLETED_ALL", {}, expireToken);
  //   const data = await processEncryptedResponse(res);
  //   if (Array.isArray(data)) {
  //     setQAList(data?.filter(Boolean));
  //   }
  // };

  // useEffect(() => {
  //   fetchCompleteCall();
  // }, []);

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
            <FilterSection />
          </div> */}
          <DataTable
            updatedColumns={updatedColumns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
                action: "READ_COMPLETED_ALL",
                input: {},
              },
              apiMethod: "post",
            }}
            tableConfig={{
              dataMapper: (item, i) => ({
                key: item?.id,
                "Agent name": item?.agent_name || null,
                "Call type": item?.call_type || null,
                "Review date": moment(item?.created_at).format("MMMM Do YYYY") || null,
                "Call duration": item?.duration || null,
                "QA Comments Summary": item?.callObservation || null,
                Action: "View",
                originalItem: item,
              }),
            }}
          />
        </div>
      </>
      <SelectAuditType
        open={isAuditTypeModalOpen}
        handleCancel={() => setIsAuditTypeModalOpen(false)}
        handleSubmit={(temptype) => {
          const width = window.screen.availWidth;
          const height = window.screen.availHeight;

          window.open(
            `/report-pdf?callId=${
              selectedRow.originalItem?.id || selectedRow.key
            }&auditTypeId=${temptype}`,
            "_blank",
            `width=${width},height=${height},left=0,top=0`
          );
        }}
      />
    </>
  );
};

export default CompleteCalls;
